import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {formatarCpf, formatarValorReal} from "../../../../utils/formatar";
import {Col, FormGroup, Row} from 'reactstrap';

@inject("store")
@observer
export class DetalhamentoContratosAnterioresEValidacoes extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
    }

    indexN(cell, row, enumObject, index) {
        return (<div>{index+1}</div>)
    }

    renderAlertas(){
        if(this.props.controller.alertas.length > 0){
            return (
                <div>
                    <Row>
                        <Col xs={12} md={12}>
                            <FormGroup>
                                <div>
                                    <div className="alert-item">
                                        {this.props.controller.alertas}
                                    </div>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    renderContratorAnteriores(){
        if(this.props.controller.contratos.length > 0){
            return(
                <div>
                    <h4>Contratos anteriores</h4>
                    <BootstrapTable data={ this.props.controller.contratos } maxHeight='400px' striped hover condensed>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '150'} columnTitle dataField='id' isKey>#</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '200'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='cpf' dataFormat={ formatarCpf }>CPF</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '200'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='nomeCargo'>Cargo</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '200'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='salario' dataFormat={ formatarValorReal }>Salário</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '80'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='sistemaOrigem'>Origem</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '200'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='tipoContratacao'>Tipo contratação</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '100'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='dataInicio'>Data início</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '100'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='dataFim'>Data fim</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '200'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='nomeGestorArea'>Gestor/Área</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 900 ? 'auto' : '200'} columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataField='observacoes'>Detalhes</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            )
        }
    }

    renderValidacoes(){
        if ( this.props.controller.validacoes.length){
            return (
                <div>
                    <h4>Validações</h4>
                    <BootstrapTable data={ this.props.controller.validacoes } maxHeight='400px' striped hover condensed>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField="any" dataFormat={this.indexN} isKey>#</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '200'} columnTitle dataField='cpf'>CPF</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '200'} columnTitle dataField='key'>Validação</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                { this.renderAlertas() }
                { this.renderContratorAnteriores() }
                { this.renderValidacoes() }
            </div>
        )
    }
}